<template>
    <div>
        <v-container class="tabHeader the-main-concept">
            <h1>{{$t('group.friends')}}</h1>
        </v-container>
    <v-container class="friends-list-page the-main-concept">
        <v-container class="friends-cont1">
            <div class="search-individual-friends">
                <v-flex class="level1 ex-group-search">
                    <search-individual-components></search-individual-components>
                </v-flex>
            </div>
            <div class="form-section">
                <v-form class="friend-list-input-form" ref="form" v-model="validInvitationEmail" lazy-validation>
                    <v-flex>
                        <v-text-field
                                v-model="mailAddressForInvitation"
                                :label="$t('send_invitation_via_email')"
                                :rules="emailRules"
                                required
                                flat solo
                                class="via-email-input"
                        />
                    </v-flex>
                    <v-flex class="via-send-btn-sect">
                        <v-btn
                                :disabled="!validInvitationEmail"
                                @click="sendInvitationMail"
                                class="via-send-btn"
                                flat
                                solo
                                :ripple="false"
                        >
                            <v-icon class="loading-icon" v-if="loading">fa fa-spinner fa-pulse</v-icon>
                            <v-icon class="send-icon" v-if="!loading">icon-arrow-348</v-icon>
                        </v-btn>
                    </v-flex>
                </v-form>
            </div>
        </v-container>
        <v-container class="friends-cont2">
            <v-layout row wrap>
                <v-flex d-flex xs12 sm4 md4 lg3 ex-friend-item v-for="(friend,index) in friends" :key="index">
                    <v-list-tile-avatar class="avatar-image">
                        <img v-if="isLogged && friend.Friend.image" :src=" apiUrl+ friend.Friend.image" :alt="$t('avatar')"/>
                        <img v-else src="../../../src/assets/images/NoImage.png" :alt="$t('avatar')"/>
                    </v-list-tile-avatar>
                    <v-list-tile-content class="friend-info-content">
                        <router-link :to="`/accounts/${friend.Friend.id}`">
                            <v-list-tile-title class="name-info"
                                               v-html="friend.Friend.firstName + ' ' + (friend.Friend.lastName || '')"></v-list-tile-title>
                        </router-link>
                        <v-flex class="d-flex flex-row product-status">
                            <p class="m25-0 ex-info-text">{{$t('received') + ':'}}<span class="ml-2">{{friend.receivedProductsCount}}</span>
                            </p>
                            <p class="m25-0 ex-info-text ml-2">{{$t('given') + ':'}}<span class="ml-2">{{friend.givenProductsCount}}</span>
                            </p>
                        </v-flex>
                    </v-list-tile-content>
                    <v-list-tile-action class="dropdown-btn-sect">
                        <v-menu
                                nudge-bottom="5"
                                nudge-left="155"
                                content-class="dropdown-menu"
                                transition="slide-y-transition"
                                class="dropdown-menu-sect"
                        >
                            <v-btn class="dropdown-btn" flat solo :ripple="false" slot="activator">
                                <v-icon>icon-more-hover</v-icon>
                            </v-btn>
                            <v-card class="dropdown-card">
                                <v-list dense class="btn-list">
<!--                                    <div v-if="loggedUser.id !== friend.Friend.id" class="btn-list-item">-->
<!--                                        <v-list-tile flat solo :ripple="false" class="message-send-btn">-->
<!--                                            <v-icon>icon-message</v-icon>-->
<!--                                            Send message-->
<!--                                        </v-list-tile>-->
<!--                                    </div>-->
                                    <div class="btn-list-item">
                                        <v-list-tile @click="deleteModal(friend.Friend.id)" flat solo :ripple="false"
                                                     class="delete-friend-btn">
                                            <v-icon>icon-remove-565</v-icon>
                                          {{$t('accounts.un_friend')}}
                                        </v-list-tile>
                                    </div>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </v-list-tile-action>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog" max-width="550px">
            <v-card class="delete-friend-modal">
                <v-card-title  class="headline-title">
                    <span>{{$t('accounts.delete_friend')}}</span>
                </v-card-title>
                <v-card-text class="delete-modal-text">
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex>
                                <span>{{$t('accounts.delete_friend_text')}}</span>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions class="delete-friend-btn-sect">
                    <v-btn flat :ripple="false" class="cancel-delete-btn" @click.native="closeModal">{{$t('accounts.cancel')}}</v-btn>
                    <v-btn flat :ripple="false" @click.native="deleteFriend" class="accept-delete-btn">{{$t('accounts.delete')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import SearchIndividualComponents from '../profilePage/components/SearchIndividualUsers'

export default {
  name: 'MyFriends',
  components: {
    SearchIndividualComponents
  },
  data: () => ({
    apiUrl: process.env.ROOT_API,
    loading: false,
    validInvitationEmail: false,
    isLogged: true,
    signUpData: false,
    mailAddressForInvitation: '',
    dialog: false,
    deleteFriendId: null
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData,
      friends: state => state.profile.userData.friends
    }),
    emailRules () {
      return [
        v => !!v || this.$t('email_required'),
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('email_not_valid')
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.closeModal()
    }
  },
  methods: {
    sendInvitationMail () {
      if (this.$refs.form.validate()) {
        this.loading = true
        let data = {
          email: this.mailAddressForInvitation,
          firstName: this.$store.state.auth.userData.firstName,
          lastName: this.$store.state.auth.userData.lastName,
          inviterMail: this.$store.state.auth.userData.email
        }
        this.$store.dispatch('profile/sendInvitationToFriend', data).then(response => {
          this.$toastr(response.type, response.message, this.$t(response.type))
          this.loading = false
        }).catch(err => {
          console.log(err)
        })
      }
    },
    deleteFriend () {
      if (this.deleteFriendId) {
        this.$store.dispatch('profile/deleteFriend', this.deleteFriendId).then(response => {
          this.$toastr(response.type, response.message, this.$t(response.type))
        }).catch(err => {
          console.log(err)
        })
      }
      this.closeModal()
    },
    deleteModal (friendId) {
      this.deleteFriendId = friendId
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
    }
  },
  beforeMount () {
    this.$store.dispatch('profile/getUserFriendsData')
      .then(response => {

      }).catch(err => {
        console.log(err)
      })
  }
}
</script>
<!--@click="deleteModal(friend.Friend.id)"-->
<style lang="scss" scoped>
    @import "../../assets/sass/desktop/myFriends.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/MyFriends.vue